import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

export default class MetasService {
  static getHeaders() {
    const token = JSON.parse(localStorage.getItem('accessToken'));
    return { Authorization: `Bearer ${token}` };
  }

  static async getLineas() {
    try {
      const res = await axios.get(`${adminUrl}/mrr-goals/lineas`, { headers: this.getHeaders() });
      return { status: 'ok', data: res.data.data };
    } catch { return { status: 'error', data: {} }; }
  }

  static async getGoals(year, quarter) {
    try {
      const res = await axios.get(`${adminUrl}/mrr-goals`, {
        headers: this.getHeaders(),
        params: { year, quarter },
      });
      return { status: 'ok', data: res.data.data };
    } catch { return { status: 'error', data: [] }; }
  }

  static async getProgress(year, quarter) {
    try {
      const res = await axios.get(`${adminUrl}/mrr-goals/progress`, {
        headers: this.getHeaders(),
        params: { year, quarter },
      });
      return { status: 'ok', data: res.data.data };
    } catch { return { status: 'error', data: [] }; }
  }

  static async upsert(pais, lineaNegocio, year, quarter, targetUSD) {
    try {
      const res = await axios.post(
        `${adminUrl}/mrr-goals`,
        { pais, lineaNegocio, year, quarter, targetUSD },
        { headers: this.getHeaders() }
      );
      return { status: 'ok', data: res.data.data };
    } catch { return { status: 'error' }; }
  }

  static async remove(id) {
    try {
      await axios.delete(`${adminUrl}/mrr-goals/${id}`, { headers: this.getHeaders() });
      return { status: 'ok' };
    } catch { return { status: 'error' }; }
  }
}
